import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { FilterMatchMode } from 'primereact/api';
import { Dialog } from 'primereact/dialog';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import AddClassMasterDialog from './AddClassMaster';
import Toast from '../../Shared/Toast/Toast';
import DeleteConfirmation from '../../Dialogs/DeleteConfirmation';
import { InputSwitch } from 'primereact/inputswitch';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import { useNavigate } from 'react-router-dom';


const ClassMaster = () => {
    const { catchResponse } = useCatchResponse();
    const navigate = useNavigate();
    const [classList, setClassList] = useState([]);
    const [masterData, setMasterData] = useState([]);
    const [classId, setClassId] = useState('');
    const [visible, setVisible] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        ClassName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Board: { value: null, matchMode: FilterMatchMode.CONTAINS },
        MediumName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
    const [deleteId, setDeleteId] = useState('');
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [securityUserID, setSecurityUserID] = useState("");
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [visibleStudentList, setVisibleStudentList] = useState(false);
    const [masterStudentList, setMasterStudentList] = useState([]);
    const [updatedStatus, setUpdatedStatus] = useState('');
    const [isStatusConfirmation, setIsStatusConfirmation] = useState(false);
    const [academicYearList, setAcademicYearList] = useState([]);
    const [selectedYear, setSelectedYear] = useState('');


    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        getFinancialYearData(loginData);

    }, []);

    const getFinancialYearData = async (userData) => {
        const years = await CommonConfig.getFinancialYears(userData?._id);
        setAcademicYearList(years);
        const currentYear = CommonConfig.getCurrentFinancialYear(years);
        const selectedAcYear = CommonConfig.getCookie('selectedAcademicYear');
        setSelectedYear(selectedAcYear ?? currentYear?.value);
        await GetClassList(userData?._id, selectedAcYear ?? currentYear?.value);
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };

    const GetClassList = async (id, academicYearId) => {
        try {
            let data = {
                UserID: id,
                FinancialYearId: academicYearId
            }
            await api.post(APIConstant.path.getClassList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setClassList(res.data);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const UpdateStatus = async () => {
        try {
            let data = {
                id: deleteId,
                Status: updatedStatus
            }
            await api.post(APIConstant.path.updateClassDetailStatus, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Class status updated successfully' });
                    setDeleteId('');
                    setUpdatedStatus('');
                    GetClassList(securityUserID, selectedYear);
                }
                handleCloseStatus();
            }).catch(err => {
                Loader.hide();
                setDeleteId('');
                setUpdatedStatus('');
                handleCloseStatus();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const DeleteClass = async () => {
        try {
            let data = {
                id: deleteId
            }
            await api.post(APIConstant.path.deleteClassDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Class deleted successfully' });
                    setDeleteId('');
                    setUpdatedStatus('');
                    GetClassList(securityUserID, selectedYear);
                }
                handleClose();
            }).catch(err => {
                handleClose();
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const actionBodyTemplate = (rows) => {
        return (
            <React.Fragment>
                <div className='p-d-flex p-ai-center p-jc-end'>
                    <Button icon="pi pi-pencil" className="e-sction-btn p-m-0" onClick={() => {
                        setClassId(rows._id)
                        setMasterData(rows);
                        setIsEdit(true)
                        setVisible(true)
                    }} />
                    <Button icon="pi pi-trash" className="e-sction-btn p-m-0 p-m-2" onClick={(e) => {
                        setIsDeleteConfirmation(true);
                        setDeleteId(rows._id);
                    }} />
                    <InputSwitch
                        checked={rows?.Status === 'Active' ? true : false}
                        onChange={(e) => {
                            toggleActiveStatus(rows._id, e.value);
                        }}
                        className="p-ml-2 p-mt-1"
                    />
                </div>
            </React.Fragment>
        );
    };

    const toggleActiveStatus = (id, status) => {
        setDeleteId(id);
        setUpdatedStatus(status === true ? 'Active' : 'Inactive');
        setIsStatusConfirmation(true);
    };

    const onCancel = () => {
        setVisible(false);
        setClassId('');
        setIsEdit(false);
        setMasterData([]);
        GetClassList(securityUserID, selectedYear);
    }

    const actionBodyTemplateSrNo = (data, props) => {
        return props.rowIndex + 1;
    };

    const nameBodyTemplate = (row) => {
        return (
            <span
                style={{ color: "#1a73e8", cursor: "pointer", textDecoration: "underline" }}
                onClick={() => navigate('/viewEdit-student-master', {
                    state: {
                        userId: row?.id,
                        isEdit: false
                    }
                })}
            >
                {row?.Name}
            </span>
        );
    };

    const countBodyTemplateSrNo = (data, props) => {
        return <div onClick={() => {
            setVisibleStudentList(true);
            GetClassStudentsList(data?._id);
        }}>{data?.StudentListCount}</div>
    };

    const GetClassStudentsList = async (id) => {
        try {
            let data = {
                ClassId: id,
                FinancialYearId: selectedYear,
                UserID: securityUserID
            }
            Loader.show();
            await api.post(APIConstant.path.GetClassConfigStudentDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    setMasterStudentList(res?.data);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={(e) => DeleteClass()}
            />
        </div>
    );

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };

    const renderStatusFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleCloseStatus}
            />
            <Button
                label="Save"
                className="btn-text-action-primary"
                onClick={(e) => UpdateStatus()}
            />
        </div>
    );

    const handleCloseStatus = () => {
        setIsStatusConfirmation(false)
    };

    return (
        <div className='wayment-owner-dashboard et-master-page'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-clone"></i>
                    <h2>Class Master</h2>
                </div>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="searchbar-area e-searchbar-area">
                        <i className="pi pi-search" />
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Global Search"
                        />
                    </div>
                    <Button icon="pi pi-plus" className="e-h-btn" onClick={(e) => setVisible(true)} />
                </div>
            </div>
            <DataTable
                value={classList}
                paginator
                rows={rows}
                first={first}
                filters={filters}
                filterDisplay="menu"
                globalFilterFields={['ClassName', 'Board', 'MediumName', 'SectionFullName', 'StudentListCount', 'TotalCapacity']}
                responsiveLayout="scroll"
                paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                rowsPerPageOptions={[5, 10, 20]}
                currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                onPage={onPageChange}
                className='custom-table'
                scrollHeight='calc(100vh - 120px)'
                size='small'
            >
                <Column field="id" body={actionBodyTemplateSrNo} header="Sr No." style={{ minWidth: '6rem', maxWidth: '6rem' }} />
                <Column
                    field="ClassName"
                    header="Class No" />
                <Column
                    field="Board"
                    header="Board" />
                <Column
                    field="MediumName"
                    header="Medium" />
                <Column
                    field="SectionFullName"
                    header="Section" />
                <Column
                    body={countBodyTemplateSrNo}
                    header="Students" />
                <Column
                    field="TotalCapacity"
                    header="Total Capacity"
                />
                <Column
                    field="TypeName"
                    header="Type"
                />
                <Column body={actionBodyTemplate} header="Action" headerStyle={{ width: 'auto', textAlign: 'end' }} />
            </DataTable>
            <Dialog
                header={classId ? "Edit Class Master" : "Add Class Master"}
                className='dialog-popup'
                visible={visible}
                onHide={() => onCancel()}
                draggable={false}
                style={{ width: '60vw' }}
                position="center"
            >
                <AddClassMasterDialog masterData={masterData} isEdit={isEdit} ID={classId} onCancel={onCancel} academicYearList={academicYearList} />

            </Dialog>
            <Dialog
                header="Students List"
                visible={visibleStudentList}
                onHide={() => {
                    setVisibleStudentList(false)
                    setMasterStudentList([]);
                }}
                draggable={false}
                position="center">

                <div className="p-col-12 p-card p-p-3">
                    <DataTable value={masterStudentList} paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                        currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records" rowsPerPageOptions={[10, 20, 50]} className='custom-table'
                        scrollHeight='calc(100vh - 120px)'
                        size='small'>
                        <Column body={actionBodyTemplateSrNo} header="Sr No." />
                        <Column field="Name" header="Student Name" body={nameBodyTemplate} />
                        <Column field="Email" header="Email" />
                        <Column field="Phone" header="Phone" />
                    </DataTable>
                </div>
            </Dialog>
            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>
            <Dialog
                visible={isStatusConfirmation}
                onHide={handleCloseStatus}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Status Update</span>
                    </div>
                }
                footer={renderStatusFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <div>
                    <p>
                        Are you sure you want to update status?
                    </p>
                </div>
            </Dialog>
        </div>
    );
};

export default ClassMaster;
